var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 11.575L15.275 15.475C15.4583 15.6583 15.55 15.8917 15.55 16.175C15.55 16.4583 15.4583 16.6917 15.275 16.875C15.0917 17.0583 14.8583 17.15 14.575 17.15C14.2917 17.15 14.0583 17.0583 13.875 16.875L9.275 12.275C9.175 12.175 9.10417 12.0667 9.0625 11.95C9.02083 11.8333 9 11.7083 9 11.575C9 11.4417 9.02083 11.3167 9.0625 11.2C9.10417 11.0833 9.175 10.975 9.275 10.875L13.875 6.275C14.0583 6.09167 14.2917 6 14.575 6C14.8583 6 15.0917 6.09167 15.275 6.275C15.4583 6.45833 15.55 6.69167 15.55 6.975C15.55 7.25833 15.4583 7.49167 15.275 7.675L11.375 11.575Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.88817b06bb551c3395a97500a2d1154f.svg";
export { ForwardRef as ReactComponent };